import { useEffect, useState } from 'react';
import ConsentFormService from '../services/consentFormService';
import usePermissions from './usePermissions';
import useStorePlan from './useStorePlan';
import { Permissions } from '../constants/Permissions';

/** The store's consent forms, for staff screens that only describe them. Empty when unavailable. */
const useStoreConsentForms = (storeId) => {
  const { hasPermission } = usePermissions(storeId);
  const { entitlements } = useStorePlan(storeId, Boolean(storeId));
  const enabled = Boolean(storeId) && hasPermission(Permissions.ConsentFormsRead) && Boolean(entitlements?.allowsConsentForms);
  const [consentForms, setConsentForms] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setConsentForms([]);
      return undefined;
    }

    let cancelled = false;
    ConsentFormService.getConsentForms(storeId)
      .then((forms) => {
        if (!cancelled) {
          setConsentForms(forms);
        }
      })
      .catch((loadError) => {
        console.error('Failed to load consent forms:', loadError);
        if (!cancelled) {
          setConsentForms([]);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, storeId]);

  return consentForms;
};

export default useStoreConsentForms;
